import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the api
 */
export class DistanceSummaryService extends BaseService {

	constructor() {	
		super();
	}
	
	async getDistanceSummaries(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/distance-summaries/' + params);		
		return data;		
	}
	
	exportDistanceSummaries(paging) {	
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/distance-summaries/export' + params);		
	};	
	
	async getDistanceSummary(tractorMileageId) {
		var data = await this.makeGETRequest('/api/resource/distance-summaries/' + tractorMileageId);		
		return data;		
	}
	
	async saveDistanceSummary(summary, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/distance-summaries/' + summary.tractorMileageId, summary);
		} else {
			saved = await this.makePOSTRequest('/api/resource/distance-summaries', summary);
		}
		return saved;		
	}	
	
	async activateDistanceSummaries(recordIds) {	
		var result = await this.makePUTRequest('/api/resource/distance-summaries/activate', recordIds);
		return result;
	}	

	async inactivateDistanceSummaries(recordIds) {	
		var result = await this.makePUTRequest('/api/resource/distance-summaries/inactivate', recordIds);
		return result;
	}	
	
	async deleteDistanceSummaries(tractorMileageIds) {
		var data = await this.makeDELETERequest('/api/resource/distance-summaries', tractorMileageIds);		
		return data;		
	}
	
	async deleteBulkDistanceSummaries(bulkRequest) {
		var data = await this.makeDELETERequest('/api/resource/distance-summaries/bulk',  bulkRequest);		
		return data;		
	}	
	
	//trip sheets////////
	
	async getTripSheets(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/tripsheets/' + params);		
		return data;		
	}
	
	exportTripSheets(paging) {	
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/tripsheets/export' + params);		
	};	
	
	async getTripSheet(tripSheetId) {
		var data = await this.makeGETRequest('/api/resource/tripsheets/' + tripSheetId);		
		return data;		
	}
	
	async saveTripSheet(sheet, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/tripsheets/' + sheet.tripSheetId, sheet);
		} else {
			saved = await this.makePOSTRequest('/api/resource/tripsheets', sheet);
		}
		return saved;		
	}		
	
	async getTripSheetPreview(tripSheetId) {
		var data = await this.makeGETRequest('/api/resource/tripsheets/' + tripSheetId + '/preview');		
		return data;		
	}	
	
	async getTripSheetDetails(tripSheetId) {
		var data = await this.makeGETRequest('/api/resource/tripsheets/' + tripSheetId + '/details');		
		return data;		
	}
	
	async saveTripSheetDetail(detail, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/tripsheets/' + detail.tripSheetId + '/details/' + detail.tripSheetDetailId, detail);
		} else {
			saved = await this.makePOSTRequest('/api/resource/tripsheets/' + detail.tripSheetId + '/details', detail);
		}
		return saved;		
	}	
	
	async completeTripSheet(tripSheetId) {	
		var result = await this.makePUTRequest('/api/resource/tripsheets/' + tripSheetId + '/complete');
		return result;
	}	
	
	async deleteTripSheet(tripSheetId) {
		var data = await this.makeDELETERequest('/api/resource/tripsheets/' + tripSheetId);		
		return data;		
	}
	
	async deleteTripSheetDetail(tripSheetId, detailId) {
		var data = await this.makeDELETERequest('/api/resource/tripsheets/' + tripSheetId + '/details/' + detailId);		
		return data;		
	}	
	
}